import { useEffect, useState } from 'react'
import mapError from '../../utils/mapError/userManagement'
import { LOGIN_ROOT } from '../../constants/routes'
import {
  ACCEPT_INVITATION_ACTION,
  CONFIRM_ACCOUNT_TITLE,
  GENERIC_INVITATION_ERROR,
} from '../../constants/ui.labels'
import { isAutomationAccount } from '../../config/feature-flags'
import AcceptInvitationForm from '../../components/AcceptInvitationForm'
import AccountRecoveryBase from '../../components/AccountRecoveryBase'
import NoRecaptchaSecureForm from '../../components/NoRecaptchaSecureForm'
import PasswordChangeFieldGroup from '../../components/PasswordChangeFieldGroup'
import SecureForm from '../../components/SecureForm'
import ContentHeader from '../../components/ContentHeader'
import Error from '../../components/Error'
import Box from '@talkdesk/cobalt-react-box'
import Spinner from '@talkdesk/cobalt-react-spinner'
import { navigateTo } from 'mfa'

const INITIAL_FORM_DATA = {
  password: '',
  passwordConfirmation: '',
  isValid: false,
  invitationToken: null,
  error: null,
}

const AcceptInvitation = ({
  confirmationError,
  name,
  email,
  siteKey,
  disabledForm,
  loaded,
  loadingError,
  confirmed,
  location,
  onLoad,
  onConfirm,
  onExecuteRecaptcha,
}) => {
  const [formData, setFormData] = useState(INITIAL_FORM_DATA)
  const [displayToastError, setDisplayToastError] = useState(false)

  /* eslint-disable react-hooks/set-state-in-effect, @eslint-react/set-state-in-effect, @eslint-react/x-exhaustive-deps, @eslint-react/exhaustive-deps, react-hooks/exhaustive-deps */
  useEffect(() => {
    const invitationToken = new URLSearchParams(location.search).get(
      'invitation_token',
    )
    setFormData((prev) => ({ ...prev, invitationToken }))
    onLoad({ invitationToken })
  }, [])
  /* eslint-enable react-hooks/set-state-in-effect, @eslint-react/set-state-in-effect, @eslint-react/x-exhaustive-deps, @eslint-react/exhaustive-deps, react-hooks/exhaustive-deps */

  const getErrorMessage = (errorCode) =>
    formData.error ||
    (errorCode && mapError(errorCode, GENERIC_INVITATION_ERROR)) ||
    null

  const handleFormSubmit = (recaptchaResponse) => {
    const { password, passwordConfirmation, invitationToken } = formData

    onConfirm({
      password,
      passwordConfirmation,
      invitationToken,
      recaptchaResponse,
    })
    setDisplayToastError(true)
  }

  const renderForm = () => {
    const showToastError =
      (formData.error && !formData.isValid) || displayToastError

    return (
      <Box>
        <ContentHeader title={CONFIRM_ACCOUNT_TITLE} />
        {showToastError ? (
          <Error message={getErrorMessage(confirmationError)} />
        ) : null}
        {isAutomationAccount() ? (
          <NoRecaptchaSecureForm
            onSubmit={handleFormSubmit}
            submitLabel={ACCEPT_INVITATION_ACTION}
            isFormValid={formData.isValid}
            disabledForm={disabledForm}
          >
            <Box paddingY='2'>
              <AcceptInvitationForm name={name} email={email} />
              <PasswordChangeFieldGroup
                formData={formData}
                onFormChange={setFormData}
                disabledForm={disabledForm}
              />
            </Box>
          </NoRecaptchaSecureForm>
        ) : (
          <SecureForm
            onSubmit={handleFormSubmit}
            onExecuteRecaptcha={onExecuteRecaptcha}
            siteKey={siteKey}
            submitLabel={ACCEPT_INVITATION_ACTION}
            isFormValid={formData.isValid}
            disabledForm={disabledForm}
          >
            <Box paddingY='2'>
              <AcceptInvitationForm name={name} email={email} />
              <PasswordChangeFieldGroup
                formData={formData}
                onFormChange={setFormData}
                disabledForm={disabledForm}
              />
            </Box>
          </SecureForm>
        )}
      </Box>
    )
  }

  const renderLoading = () => (
    <div className='double-vertical-space'>
      <Spinner size='large' />
    </div>
  )

  if (confirmed || loadingError) {
    navigateTo(LOGIN_ROOT)
    return null
  }

  const content = loaded ? renderForm() : renderLoading()

  return <AccountRecoveryBase.Centered>{content}</AccountRecoveryBase.Centered>
}

export default AcceptInvitation
